import { getCookie } from '../utilities/helpers';
import { isEntryFlow } from '../utilities/urlResolver';


const abTesting = {
  showDaysOnCard: getCookie('abTest.showDaysOnCard'),
  customizeButton: true,
  moveMultiRates: true,
  newBackButton: getCookie('abTest.newBackButton') === 'true',
  welcomeScreen: {
    hideSkip: getCookie('abTest.welcomeScreen.hideSkip') === 'true',
  },
  mobileHomepageScrollable: false,// && getCookie('abTest.mobileHomepageScrollable'), // temporary disabled, it has some conflict with other abTesting. TODO: fix the bug
  wizardLandingStep: getCookie('abTest.landing'),
  wizardLandingStepAlternative: (getCookie('abTest.landing') === 'who2' && !isEntryFlow('link-presets-welcome')) || (window.location.search.indexOf('wizardWidget=true') > -1),
  showCardsTutorialMsgs: true, // getCookie('abTest.showCardsTutorialMsgs') === 'true',
  noEntryFlow: getCookie('abTest.noEntryFlow'),
  wizardStyleAlternativeSorting: getCookie('abTest.wizardStyleAlternativeSorting') === 'true',
  splashScreenBeforeWhoStep: getCookie('abTest.spashScreenBeforeWhoStep') === 'true',
  educationalMessages: getCookie('abTest.educationalMessages') === 'true',
  dealOfTheDay: (window?.dataGlobalSettings?.siteType !== 3), // getCookie('abTest.dealOfTheDay') === 'true',
  flexibleDates: true, // getCookie('abTest.flexibleDates') === 'true',
  crossoutPriceV2: getCookie('abTest.crossoutPriceV2') === 'true',
  wizardSkip: getCookie('abTest.wizardSkip') === 'true',
  aiAssistant: getCookie('abTest.aiAssistant') === 'true',
  aiAssistantV2: (getCookie('abTest.aiAssistantV2') === 'true' || window.location.href.indexOf('enableAiAssistantV2=true') > -1),
  groupBooking: getCookie('abTest.groupBooking'),
  userPrefEnabled: getCookie('abTest.userPrefEnabled') === 'true',
  hideDateTutorial: getCookie('abTest.hideDateTutorial') === 'true',
  mobileFilterSort: getCookie('abTest.mobileFilterSort') === 'true',
};

export default abTesting;
